<template>
  <v-card flat border>
    <v-toolbar color="secondary" flat density="compact">
      <v-toolbar-title>
        <v-icon class="text-accent mr-4">mdi-calendar-multiple</v-icon>
        <span class="text-accent text-h6 text-uppercase">{{
          $t("machines.info.warranty.label")
        }}</span></v-toolbar-title
      >
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="py-2">
          <brk-date-picker
            :value="machineInfo.warrantyStartDate"
            @input="value => updateField('warrantyStartDate', value)"
            required
            :rules="[
              validationRules.required,
              validationRules.date,
              validationRules.dateInRange(
                new Date(machineInfo.warrantyStartDate),
                minWarrantyDate,
                maxWarrantyDate,
                $t('machines.info.validation.errors.warrantyStartDateInvalid')
              )
            ]"
            :label="$t('machines.info.warranty.startDate')"
            prepend-icon="mdi-calendar-start"
            :readonly="!isEditing"
            variant="underlined"
          ></brk-date-picker>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-2">
          <v-select
            :label="$t('machines.info.warranty.length')"
            :items="warrantyLengths"
            :model-value="machineInfo.warrantyLength"
            @update:model-value="value => updateField('warrantyLength', value)"
            persistent-hint
            :readonly="!isEditing"
            variant="underlined"
            prepend-icon="mdi-arrow-expand-horizontal"
            :menu-icon="isEditing ? 'mdi-chevron-down' : ''"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-2">
          <v-text-field
            :label="$t('machines.info.warranty.endDate')"
            :model-value="machineInfo.warrantyEndDate"
            variant="underlined"
            persistent-hint
            readonly
            disabled
            prepend-icon="mdi-calendar-end"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ValidationRules from "@/utils/validationrules"
import formatter from "@/utils/formatter"
import BrkDatePicker from "@/components/controls/BrkDatePicker.vue"
let validationRules = null

export default {
  components: {
    BrkDatePicker
  },
  props: ["machineInfo", "isEditing"],
  emits: ["update:machineInfo"],
  data: () => ({
    validationRules: validationRules
  }),
  beforeCreate() {
    validationRules = ValidationRules()
  },
  computed: {
    deliveryDate() {
      return this.machineInfo.deliveryDate?.length
        ? new Date(this.machineInfo.deliveryDate)
        : null
    },
    commissioningDate() {
      return this.machineInfo.commissioningDate?.length
        ? new Date(this.machineInfo.commissioningDate)
        : null
    },
    minWarrantyDate() {
      return this.commissioningDate ?? this.deliveryDate
    },
    maxWarrantyDate() {
      const maxDate = new Date(this.deliveryDate)
      maxDate.setMonth(maxDate.getMonth() + 6)
      return maxDate
    },
    warrantyLengths() {
      return [
        {
          title: `${this.$t("common.units.month", 12)}`,
          value: 12
        },
        {
          title: `${this.$t("common.units.month", 24)}`,
          value: 24
        }
      ]
    }
  },
  methods: {
    updateField(field, value) {
      const updatedModel = {
        ...this.machineInfo,
        [field]: value
      }
      const startDate = new Date(updatedModel.warrantyStartDate)
      updatedModel.warrantyStartDate = formatter().formatDate(
        startDate
      )
      const endDate = new Date(
        startDate.setMonth(startDate.getMonth() + updatedModel.warrantyLength)
      )
      updatedModel.warrantyEndDate = formatter().formatDate(endDate)

      this.$emit("update:machineInfo", updatedModel)
    }
  }
}
</script>

<style></style>
